import { resourceUsage } from "process";
import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";
export interface ICodigoBarra {
  idCoord: number;
  codigoBarras: number;
}
export interface IEstante {
  idTeste?: number | null | undefined;
  idCoord: number;
  numeroEstante: string;
  altura: string;
  comprimento: string;
  idTipoCaixa: number;
  cnpj: string;
  codigoBarras?: number;
}

type TEstante = {
    estante: IEstante[];
    paginacao: IPaginacao;
}

export interface IEstanteRetorno {
  idCoord: number;
  numeroEstante: string;
  altura: string;
  comprimento: string;
  idTipoCaixa: number;
  cnpj: string;
  nomeTipo: string;
  cliente: string;
  codigoBarras?: number;
}

const create = async (estantes: IEstante[]): Promise<void | Error> => {
  try {
    const { data } = await Api.post(`/Estante`, estantes, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );
    window.open(url);
  } catch (error: any) {
    return new Error(error.message || "Erro ao criar estante");
  }
};

const verificarDiposnibilidade = async (
  estantes: IEstante[],
  vazio: boolean
): Promise<IEstante[] | IEstanteRetorno[] | Error> => {
  try {
    const { data } = await Api.post(
      `/Estante/verificarOcupacao`,
      estantes,
      { params: { vazio } }
    );
    return data;
  } catch (error: any) {
    return new Error(error.message || "Erro ao verificar disponibilidade");
  }
};
const reimprimir = async (idCoord: number): Promise<void | Error> => {
  try {
const response = await Api.post(
        `/Estante/reimprimirBarCodEspecifico`,
        null,
        {
          params: { idCoord },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      
    } catch (error: any) {
      return new Error(error.message || "Erro ao reimprimir código de barras");
    }
  };
  

const gerarEtiqueta = async (estantes: IEstante[]): Promise<void | Error> => {
  try {
    const { data } = await Api.post(
      `/Estante/gerarEtiqueta`,
      estantes,
      { responseType: "blob" }
    );

    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );
    window.open(url);
  } catch (error: any) {
    return new Error(error.message || "Erro ao gerar etiqueta");
  }
};

const deleteByEstante = async (idsEstante: number[]): Promise<void | Error> => {
  try {
    await Api.delete(`/Estante`, { data: idsEstante });
  } catch (error: any) {
    return new Error(error.message || "Erro ao excluir estante");
  }
};
const gerarCodigoBarras = async (
  quantidadeDesejada: number
): Promise<void | Error> => {
  try {
    const { data } = await Api.post(
      `/Estante/gerarBarCod`,
      {},
      {
        params: { quantidadeDesejada },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );
    window.open(url);
  } catch (error: any) {
    return new Error(error.message || "Erro ao gerar código de barras");
  }
};
const carregarCodigos = async (page = 1, estado: boolean): Promise<TEstante | Error> => {
  try {
    const { data } = await Api.get(`/Estante/listarPorCodBarras?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&estado=${estado}&listar=true`);

    if (data) {
      return {
        estante: data.estantes,
        paginacao: data.paginacao,
      }
    }
    return new Error('Erro ao listar os registros');

  } catch (error: any) {
    return new Error(error.message || "Erro ao listar códigos de barras");
  }
};

const reimprimirCodigoBarras = async (
  idCoord: number
): Promise<void | Error> => {
  try {
    const { data } = await Api.post(
      `/Estante/reimprimirBarCodEspecifico`,
      null,
      {
        params: { idCoord },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );
    window.open(url);
  } catch (error: any) {
    return new Error(error.message || "Erro ao reimprimir código de barras");
  }
};

const listarCodigosBarras = async (
  page = 1,
  estado: boolean,
  busca?: string
): Promise<TEstante | Error> => {
  try {

    const { data } = await Api.get(`/Estante/listarPorCodBarras`, {
      params: {
        PageNumber: page,
        PageSize: Environment.LIMITE_DE_LINHAS,
        estado: estado,
        listar: true,
        codigosBarras: busca || undefined
      }
    });

    if (data) {
      return {
        estante: data.estantes,
        paginacao: data.paginacao,
      };
    }

    return new Error("Erro ao listar os registros");

  } catch (error: any) {
    return new Error(error.message || "Erro ao listar códigos de barras");
  }
};

const excluirCodigoBarras = async (
  ids: number[]
): Promise<void | Error> => {
  try {
    await Api.delete(`/Estante/apagarCodBarras`, {
      data: ids,
    });
  } catch (error: any) {
    return new Error(error.message || "Erro ao excluir código de barras");
  }
};

export const EtiquetaService = {
  create,
  verificarDiposnibilidade,
  gerarEtiqueta,
  deleteByEstante,
  reimprimir,
  
  gerarCodigoBarras,
  carregarCodigos,
  reimprimirCodigoBarras,
  listarCodigosBarras,
  excluirCodigoBarras,

};
